import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { NavBarComponent } from "./modules/shared/nav-bar/nav-bar.component";
import { SideBarComponent } from "./modules/shared/side-bar/side-bar.component";
import { Server } from './modules/shared/enums/common.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavBarComponent, SideBarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'AOC-token-locker-admin';

  ngOnInit(): void {
    initFlowbite();
  }

  /**
   * Determines whether loading page is
   */
  isLoadingPage = () => {
    const host = window.location.hostname === '54.236.53.42' ? 'development' : 'production';
    //for testing purpose
    if (host === Server.DEVELOPMENT) {
      if (window.location.pathname === '/aoc-token-locker-admin/' ) {
        console.log('aoc-token-locker-admin')
        return true;
      } else {
        return false;
      }
    } else {
      if (window.location.pathname === '/' ) {
        return true;
      } else {
        return false;
      }
    }   
  }
}
